import React from 'react'
import PropTypes from 'prop-types'

import { H1, Button, Icon } from '../Common'

import style from './SignupFacebook.scss'

import disappointed from '../../images/emojis/disappointed.svg'

function SignupFacebookNoEmail({ onInitialStep }) {
  return (
    <div className={style.wrapper}>
      <img src={disappointed} alt="Ahhh!" />
      <H1>ops!</H1>
      <p>
        Não foi possível encontrar o seu e-mail através do Facebook. Remova o aplicativo e recomece o processo. Ou
        cadastra-se por e-mail, normalmente.
      </p>
      <a
        href="https://www.facebook.com/settings?tab=applications"
        title="Remova o App do Facebook"
        rel="noopener noreferrer"
        target="_blank"
        className={style.link}
        tabIndex={0}
        autoFocus
      >
        remover o aplicativo no Facebook <Icon value="open_in_new" material />
      </a>
      <Button onClick={onInitialStep} xl>
        recomeçar através do e-mail
      </Button>
    </div>
  )
}

SignupFacebookNoEmail.propTypes = {
  onInitialStep: PropTypes.func,
}

export default SignupFacebookNoEmail



// WEBPACK FOOTER //
// ./src/components/Pages/SignupFacebookNoEmail.js